import * as React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import * as Router from "@reach/router";

const BuildButton = () => {
  const location = Router.useLocation();
  const [open, setOpen] = React.useState(false);
  console.log(location);
  const startbuild = async () => {
    handleClose();
    return fetch(
      "https://o10paniskf.execute-api.ap-northeast-1.amazonaws.com/dev/build",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
        mode: "cors",
      }
    )
      .then((res) => res.json())
      .then(console.log)
      .catch(console.error);
  };

  function handleClose() {
    setOpen(false);
  }

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setOpen(true)}
      >
        BUILD
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">ページビルド</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            最新の情報をもとにWebページの生成を行います。完了には、10分程度の時間をかかります。このボタンを頻繁に押すとサービスに影響がある可能性があるため実行にはご注意ください。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button onClick={startbuild} color="primary" autoFocus>
            実行
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default BuildButton;
